module.exports = __webpack_public_path__ + "04bc0a4936efd92ec31c607860ceb324.png";